import { motion } from 'framer-motion';
import { Lock, ShieldCheck, Database, Sliders } from 'lucide-react';

const privacyFeatures = [
  { icon: Lock, text: 'Encrypted data' },
  { icon: ShieldCheck, text: 'Privacy-first design' },
  { icon: Sliders, text: 'Sharing controls' },
  { icon: Database, text: 'Secure infrastructure' },
];

const PrivacySection = () => {
  return (
    <section id="privacy" className="section section-soft" data-testid="privacy-section">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center">
          {/* Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#1A1A1A] mb-4">
              Privacy First. Always.
            </h2>
            <p className="text-[#5A5A5A] text-lg mb-4">
              Trust is not a feature. It's our foundation.
            </p>
          </motion.div>

          {/* Features Grid */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12"
          >
            {privacyFeatures.map((feature, index) => (
              <motion.div
                key={feature.text}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.3 + index * 0.1 }}
                className="privacy-card flex flex-col items-center gap-3 p-6"
                data-testid={`privacy-feature-${index}`}
              >
                <div className="w-12 h-12 rounded-xl bg-black/5 flex items-center justify-center">
                  <feature.icon className="w-5 h-5 text-[#4A4A4A]" />
                </div>
                <span className="text-[#4A4A4A] text-sm text-center">
                  {feature.text}
                </span>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PrivacySection;
